import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addSelectedPlantId,
  addSelectedPlantIds,
  selectNotPresentAccordingToUserPlants,
} from '../../../../ducks/plants';
import FilterableList from '../../../../components/FilterableList';
import { plantFilters } from '../../../../utils/filters';
import { plantSelectionTypesEnum } from '../../../../ducks/plants/types';
import {
  booleanText,
  parseCopyRightText,
} from '../../../../utils/valuesToHumanReadable';
import SubjectCard from '../../../../components/SubjectCard';
import { helpTextPlantPresentAccordingToModel } from '../../../../utils/text';

const SelectPlants = () => {
  const dispatch = useDispatch();
  const unselectedPlants = useSelector(selectNotPresentAccordingToUserPlants);

  return (
    <FilterableList
      filterConfig={plantFilters}
      data={unselectedPlants}
      searchableByProperties={['dutchName', 'scientificName']}
      quickSelect={{
        handleSelectResults: (results) => {
          const ids = results.map((result) => result.id);
          dispatch(addSelectedPlantIds({
            selectionType: plantSelectionTypesEnum.presentAccordingToUserIds,
            plantIds: ids,
          }));
        },
      }}
      render={(filteredData) => filteredData.map((plant) => (
        <SubjectCard
          key={plant.id}
          md={6}
          lg={4}
          title={plant.dutchName}
          subtitle={plant.scientificName}
          imagePath={plant.imagePath}
          copyrightText={parseCopyRightText(plant)}
          propertiesToList={[
            {
              key: 'Gemodelleerd in jouw gebied',
              help: helpTextPlantPresentAccordingToModel,
              value: booleanText(plant.isPresentAccordingToModel),
            },
          ]}
          ranges={plant.floweringMonths}
          rangesHeading="Bloeitijd"
          handleClick={() => dispatch(addSelectedPlantId({
            selectionType: plantSelectionTypesEnum.presentAccordingToUserIds,
            plantId: plant.id,
          }))}
        />
      ))}
    />
  );
};

export default SelectPlants;
